/* eslint-disable */
<template>
  <div class="enquiry p-0">
    <div class="red-vertical"></div>
    <div class="unlogin-container">
      <div class="content">
        <div class="d-flex">
          <div class="logo">
            <img src="@/assets/images/red_health_logo.svg" class="img-fluid" />
          </div>
          <div class="header-title-section">
            <div class="header-title"><h1>Client Account Request</h1></div>
            <div class="header-sub-title">To request access to the Red Health Online System, so that you can submit requests for independent medical examinations, please complete the form below.</div>
          </div>
        </div>
        <div class="box">
          <div class="box-heading col-space-between">
            <div>Client Request Details</div>
          </div>
          <div class="box-body">
            <div class="box-row">
              <div class="box-col box-col-left">First Name <span class="text-danger">*</span></div>
              <div class="box-col box-col-right">
                <input type="text" v-model="clientRequest.firstName" class="pl-3 w-100" :class="hasError && firstNameError ? 'is-invalid' : ''" placeholder="First Name" />
                <div v-if="hasError && firstNameError" class="text-danger">{{ firstNameError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Surname <span class="text-danger">*</span></div>
              <div class="box-col box-col-right">
                <input type="text" v-model="clientRequest.surname" class="pl-3 w-100" :class="hasError && surnameError ? 'is-invalid' : ''" placeholder="Surname" />
                <div v-if="hasError && surnameError" class="text-danger">{{ surnameError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Business Email Address <span class="text-danger">*</span></div>
              <div class="box-col box-col-right">
                <input type="text" v-model="clientRequest.email" class="pl-3 w-100" :class="hasError && emailError ? 'is-invalid' : ''" placeholder="Business Email Address" />
                <div v-if="hasError && emailError" class="text-danger">{{ emailError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">
                Mobile Number <span class="text-danger">*</span>
                <div class="mt-1">(This is required for security reasons)</div>
              </div>
              <div class="box-col box-col-right">
                <input @blur="normalizePhoneField('mobile')" type="text" v-model="clientRequest.mobile" class="pl-3 w-100" :class="hasError && mobileError ? 'is-invalid' : ''" placeholder="Mobile Number" />
                <div v-if="hasError && mobileError" class="text-danger pl-3">{{ mobileError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">
                Business Landline number
              </div>
              <div  class="box-col box-col-right">
                <input @blur="normalizePhoneField('BusinessLandLineNumber')" type="text" v-model="clientRequest.BusinessLandLineNumber" class="pl-3 w-100" :class="hasError && landLineError ? 'is-invalid' : ''" placeholder="Land Line Number" />
                <div v-if="hasError && landLineError" class="text-danger">{{ landLineError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Business Name <span class="text-danger">*</span></div>
              <div class="box-col box-col-right">
                <input type="text" v-model="clientRequest.companyName" class="pl-3 w-100" :class="hasError && companyNameError ? 'is-invalid' : ''" placeholder="Company Name" />
                <div v-if="hasError && companyNameError" class="text-danger">{{ companyNameError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Business Branch Location</div>
              <div class="box-col box-col-right">
                <input type="text" v-model="clientRequest.companyBranchName" class="pl-3 w-100" :class="hasError && companyBranchNameError ? 'is-invalid' : ''" placeholder="Company Branch Location" />
                <div v-if="hasError && companyBranchNameError" class="text-danger">{{ companyBranchNameError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Business Address</div>
              <div class="box-col box-col-right">
                <div>
                  <span class="text-danger">*</span>
                  <input type="text" v-model="clientRequest.addressLine1" class="pl-3 w-75" :class="hasError && address1Error ? 'is-invalid' : ''" placeholder="Address 1" />
                  <div v-if="hasError && address1Error" class="pl-3 text-danger">{{ address1Error }}</div>
                </div>
                <input type="text" v-model="clientRequest.addressLine2" class="pl-3 w-75" :class="hasError && address2Error ? 'is-invalid' : ''" placeholder="Address 2" />
                <div v-if="hasError && address2Error" class="pl-3 text-danger">{{ address2Error }}</div>
                <div class="pl-3 w-50 d-flex">
                  <div class="w-15">City<span class="text-danger">*</span></div>
                  <div class="w-75">
                    <input :maxlength="20" type="text" v-model="clientRequest.city" class="pl-3 w-100" :class="hasError && cityError ? 'is-invalid' : ''" placeholder="City" />
                    <div v-if="hasError && cityError" class="pl-3 text-danger">{{ cityError }}</div>
                  </div>
                </div>
                <div class="pl-3 d-flex">
                  <div class="w-50 d-flex">
                    <div class="w-15">State <span class="text-danger">*</span></div>
                    <div class="w-75">
                      <select v-model="clientRequest.state" class="pl-3 textbox w-100" :class="hasError && stateError ? 'is-invalid' : ''">
                        <option hidden value="">Please choose</option>
                        <option v-for="(state, index) in states" :value="state.value">{{ state.text }}</option>
                      </select>
                      <div v-if="hasError && stateError" class="text-danger">{{ stateError }}</div>
                    </div>
                  </div>
                  <div class="w-50 d-flex">
                    <div class="w-15">Postcode <span class="text-danger">*</span></div>
                    <div class="w-75">
                      <input v-model="clientRequest.postcode" type="text" maxlength="4" class="pl-3 w-100 postcode" :class="hasError && postcodeError ? 'is-invalid' : ''" placeholder="Postcode" />
                      <div v-if="hasError && postcodeError" class="text-danger">{{ postcodeError }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>

        <div class="icon-group right-float-element">
          <v-btn dark @click="submit()">Submit</v-btn>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import Footer from '@/components/Footer'

  export default {
    name: 'Enquiry',
    components: {
      Footer
    },
    data() {
      return {
        hasError: false,
        successMessage: '',
        errorMessage: 'Please correct the errors shown above and try again.',
        clientRequest: utilities.initClientRequest(),
        states: [],
      }
    },
    computed: {
      firstNameError() {
        return utilities.getClientContactPersonNameError(this.clientRequest.firstName, 'First name')
      },
      surnameError() {
        return utilities.getClientContactPersonNameError(this.clientRequest.surname, 'Surname')
      },
      emailError() {
        return utilities.getClientContactEmailError(this.clientRequest.email, 'Business email address', true)
      },
      mobileError() {
        const s = String(this.clientRequest.mobile || '').trim()
        if (!s) {
          return 'Mobile number is required.'
        }

        return utilities.getClientContactPhoneAu12Error(s)
      },
      landLineError() {
        const s = String(this.clientRequest.BusinessLandLineNumber || '').trim()
        if (!s) {
          return ''
        }
        return utilities.getLandPhoneError(s)
      },
      companyNameError() {
        return this.getBusinessTextError(this.clientRequest.companyName, 'Business name', true)
      },
      companyBranchNameError() {
        return this.getBusinessTextError(this.clientRequest.companyBranchName, 'Business branch location', false)
      },
      address1Error() {
        return this.getBusinessTextError(this.clientRequest.addressLine1, 'Address line 1', true)
      },
      address2Error() {
        return this.getBusinessTextError(this.clientRequest.addressLine2, 'Address line 2', false)
      },
      cityError() {
        return utilities.getValidateCityError(this.clientRequest.city)
      },
      stateError() {
        return this.clientRequest.state ? '' : 'State is required.'
      },
      postcodeError() {
        const s = String(this.clientRequest.postcode || '').trim()
        if (!s) {
          return 'Postcode is required.'
        }
        if (!/^[0-9]{4}$/.test(s)) {
          return 'Postcode must be exactly 4 digits.'
        }
        return ''
      },
    },
    methods: {
      normalizePhoneField(field) {
        const raw = this.clientRequest[field]
        if (raw === undefined || raw === null || String(raw).trim() === '') {
          this.clientRequest[field] = ''
          return
        }
        this.clientRequest[field] = utilities.normalizeAuPhoneInput(raw)
      },
      getBusinessTextError(value, label, required) {
        const s = String(value || '').trim()
        if (!s) {
          return required ? `${label} is required.` : ''
        }
        if (s.length > 100) {
          return `${label} must not exceed 100 characters.`
        }
        if (!/(?=.*[A-Za-z])/.test(s)) {
          return `${label} must include at least one English letter.`
        }
        if (!/^[0-9A-Za-z\s\-,.'&/\\]+$/.test(s)) {
          return `${label} may only contain English letters, numbers, spaces, and these characters: - , . ' & / \\`
        }
        return ''
      },
      async submit() {
        if (this.firstNameError || this.surnameError || this.emailError || this.mobileError || this.landLineError ||
          this.companyNameError || this.companyBranchNameError || this.address1Error || this.address2Error ||
          this.cityError || this.stateError || this.postcodeError) {
             this.hasError = true
             utilities.showAlert(".alert-danger")
             return false
        }

        await this.$store.dispatch('loading/setLoadComponent', true)
        var params = {
          FirstName: this.clientRequest.firstName,
          Surname: this.clientRequest.surname,
          BusinessEmailAddress: this.clientRequest.email,
          Mobile: this.clientRequest.mobile,
          CompanyName: this.clientRequest.companyName,
          CompanyBranchName: this.clientRequest.companyBranchName,
          AddressLine1: this.clientRequest.addressLine1,
          AddressLine2: this.clientRequest.addressLine2,
          City: this.clientRequest.city,
          State: this.clientRequest.state,
          PostCode: this.clientRequest.postcode,
          IsActioned: 0,
          BusinessLandLineNumber: this.clientRequest.BusinessLandLineNumber
        }
        var result = await utilities.postClientRequest(params)
        if(result) {
          // this.successMessage = "Client request created successfully."
          // utilities.showAlert(".alert-success")
          $(".icon-group button").attr("disabled", true)
          setTimeout(() => {
            this.$router.push({ name: 'login', params: { messageProps: 'Thank you for submitting your details.  We will be in touch shortly.' } })
          }, 200)
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },
      loadData() {
        this.states = utilities.getStates()
      },
    },
    beforeMount() {
      this.loadData()
    },
    mounted() {
      $(".postcode").on('input', (e) => {
        if (this.clientRequest.postcode && this.clientRequest.postcode.length > 4) {
          this.clientRequest.postcode = this.clientRequest.postcode.slice(0, 4)
        }
      })
    },
  }
</script>
